import React from 'react';
import { Typography, TypographyVariant, Container, Orientation, DensitySpacing, ComponentStrength } from '@tcc/fds';
import { LocalizedMeasurementQU } from '../../../../types';

import styles from '../RegionReport.css';

interface SummaryItemProps {
  defaultValue?: string;
  localizedMeasurement?: LocalizedMeasurementQU;
  label: string;
  dataTestId: string;
}

export const SummaryItem: React.FC<SummaryItemProps> = ({
  label,
  dataTestId,
  localizedMeasurement,
  defaultValue = '-'
}) => {
  const displayValue = localizedMeasurement?.q ?? defaultValue;
  const displayValueUnit = localizedMeasurement?.u ? ` (${localizedMeasurement?.u})` : '';
  return (
    <Container
    orientation={Orientation.Vertical}
    gap={DensitySpacing.Together}
    transparent
    strength={ComponentStrength.Regular}
    >
      <Typography tag='span' variant={TypographyVariant.Number} testId={`frr-region-report-summary-${dataTestId}-q`}>
        {displayValue}
      </Typography>
      <Typography
        variant={TypographyVariant.Description}
        testId={`frr-region-report-summary-${dataTestId}-u`}
        className={styles.headerSummary}>
        {label}
        <br />
        <span>{displayValueUnit}</span>
      </Typography>
    </Container>

  );
}
